import React from "react";
import "../../../assets/css/general/loader/Loader.css";

/* ══════════════════════════════════════════
   Reusable Loader Component
   Usage:
   <Loader message="Students la rahe hain..." />
   message prop optional hai, default niche diya hua hai.
══════════════════════════════════════════ */
const Loader = ({ message = "Please wait, Loading data ..." }) => {
  return (
    <div className="gcAdminLoader">
      <div className="gcAdminLoader-book">
        <svg width="52" height="52" viewBox="0 0 64 64" fill="none">
          {/* Left page */}
          <path
            className="gcAdminLoader-page gcAdminLoader-page--left"
            d="M32 14C26 10 16 9 8 11v34c8-2 18-1 24 3V14z"
            fill="#0f6d8c"
          />
          {/* Right page */}
          <path
            className="gcAdminLoader-page gcAdminLoader-page--right"
            d="M32 14C38 10 48 9 56 11v34c-8-2-18-1-24 3V14z"
            fill="#158fb3"
          />
          {/* Spine */}
          <rect x="30.5" y="12" width="3" height="36" fill="#0a4f66" />
        </svg>
      </div>

      <div className="gcAdminLoader-dots">
        <span className="gcAdminLoader-dot" />
        <span className="gcAdminLoader-dot" />
        <span className="gcAdminLoader-dot" />
      </div>

      <p className="gcAdminLoader-message">{message}</p>
    </div>
  );
};

export default Loader;